<!--
 * @Author: wangjiaxiang
 * @Date: 2022-03-21 14:43:06
 * @LastEditTime: 2022-10-26 10:00:48
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /xingmahui_front/src/views/contents/babyWikipedia/list.vue
 *
-->
<template>
  <div
    id="powdered_Milk_warpper"
    :class="{ noTipsShow: !editFlagTip }"
    class="powdered_Milk_warpper"
  >
    <babyInfoHeader
      @babyChange="babyChangeHandler"
      @changeeditFlagTip="changeeditFlagTip"
      @clickSharehandler="clickSharehandler"
    ></babyInfoHeader>
    <!-- 轮播图数据 -->
    <div
    class="power-milk"
    v-if="bannerList != null && bannerList.length > 0"
    >
      <mySwiper
        class="milk-swiper"
        v-if="bannerList.length > 0"
        :autoplay="bannerList.length > 0"
        :loop="bannerList.length > 1 ? true : false"
        :paginationFlag="bannerList.length > 1 ? true : false"
        :slidesNum="1"
        :swipeid="'food_column_swiper'"
        @slideClick="toDetailBanner"
        @slideChange="slideChange"
      >
        <div
          v-for="(item, index) in bannerList"
          :key="index"
          slot="swiper-con"
          :data-item="JSON.stringify(item)"
          :databanner="JSON.stringify({...resourceNiche(item),xmh5_ziyuanwei_position: index+1})"
          :style="{ backgroundImage: 'url(' + item.resImgUrl + ')' }"
          class="swiper-slide milk-swiper-fill"
        >
<!--            &lt;!&ndash; 安卓手机，并且url为外链 &ndash;&gt;-->
<!--            <template v-if="/(http|https):\/\/([\w.]+\/?)\S*/.test(item.jumpTargetUrl)">-->
<!--              <a v-if="/(http|https):\/\/([\w.]+\/?)\S*/.test(item.jumpTargetUrl)" :href="item.jumpTargetUrl"></a>-->
<!--            </template>-->

        </div>
      </mySwiper>
      <template  v-for="(banner,index) in bannerList">
        <div class="milktagWrap" v-if="banner.jumpType === 3"  :key="banner.resImgUrl" v-show="activeIndex == index">
          <openWxTag
            :id="'homeBanner'+banner.id"
            :path="banner.jumpTargetUrl"
            :appId="banner.miniProgramTypeAppId"
            btnStyle="width:100%;height:200px"
            @sensorsFn="bannerClick(banner, index)"
          ></openWxTag>
        </div>
      </template>
    </div>
    <myrumor ref="getQuestion" @showAnswer="onShowAnswer"></myrumor>
    <milk-powder-star ref="milkPowderStar"></milk-powder-star>
    <myselection></myselection>
    <!--    // 京城名医视频-->
    <foodVedio
        ref="childVideo"
        :showVedio="showVideo"
        :videoDetail="doctorInfo"
        :videoId="doctorInfo.id"
        getContainer="#HorizontalScreen"
        isHfindex="true"
        :isShowComment="true"
        @hideVedio="hideVideoEvent"
        @isUserLogin="isUserLogin"
    />
    <!-- 分享关注引导 -->
    <share-guide ref="shareGuide"></share-guide>
  </div>
</template>
<script>
//组件
import babyInfoHeader from '@/components/contents/powderedMilk/babyInfo_header/index.vue'
import shareGuide from '@/components/activity/donation_active/shareGuide.vue' // 分享弹窗
import milkPowderStar from '@/components/contents/powderedMilk/milkPowderStar/index.vue'
// 方法
import {
  fomatterNum,
  getCookie,
  isUserEdit,
  isUserLogin, resourceNiche,
} from '@/assets/js/common.js'
import myselection from '@/components/contents/powderedMilk/selection/index.vue' //引入精选专题组件
import myrumor from '@/components/contents/powderedMilk/rumor/index.vue' //引入每日辟谣组件
import mySwiper from "@/components/common/mySwiper/mySwiper.vue";
import openWxTag from '@/components/common/openWeappTag/index.vue'
import { getPageListOnLine } from "@/utils/commonApiList.js";
import * as until from "@assets/js/common";
import foodVedio from '@/views/contents/bjfamousdoctor/component/video.vue'
import {xmhziyuanwei_data_expo} from "@assets/js/BuriedPointEvent";
export default {
  name: 'powderedMilkList',
  data() {
    return {
      userInfo: {},
      show: false,
      editFlagTip: false,
      bannerList: [],
      handleItem: {},
      activeIndex: 0,
      showVideo:false,
      doctorInfo:{}
    }
  },
  components: {
    babyInfoHeader,
    myselection,
    myrumor,
    milkPowderStar,
    shareGuide,
    mySwiper,
    openWxTag,
    foodVedio
  },
  activated() {
    this.$store.commit('changeIncludes', ['powderedMilk', 'powderedMilkList'])
  },
  created() {
    var shareDataParams = {
      shareLink: location.href.split('#')[0],
      shareDesc: '你要的奶粉知识都在这里了',
      shareTitle: '超全奶粉知识,三甲医院专家专业解读',
      imgUrl: 'https://image-mom.feihe.com/wxshare/powderedMilk.png', //必须是绝对路径
    }
    this.wxJsSet.wxShare('fx', shareDataParams, this)
    // 未登录，不显示提示信息
    if (isUserLogin()) {
      this.editFlagTip = false
    } else {
      if (isUserEdit()) {
        this.editFlagTip = false
      } else {
        if (JSON.parse(sessionStorage.getItem('editFlagTip'))) {
          this.editFlagTip =
            !JSON.parse(sessionStorage.getItem('editFlagTip')) || true
        }
      }
    }

    this.initPage()
    this.getExpertbanner()
  },

  mounted() {
    console.log('isUserEdit', isUserEdit())
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name != 'milkArticleLists' &&
      to.name != 'historylist' &&
      to.name != 'BabyDetail'
    ) {
      this.$store.commit('changeIncludes', [])
    }
    next()
  },

  methods: {
    resourceNiche,
    isUserLogin,
    fomatterNum,
    getCookie,
    // 视频播放返回按钮
    hideVideoEvent() {
      // document.title = "";
      this.showVideo = false
    },
    slideChange(index) {
      this.activeIndex = index == this.bannerList.length + 1 ? 0 : index - 1
      this.setBackground(this.bannerList[this.activeIndex])
    },
    setBackground(item){
       let dom = document.getElementById("powdered_Milk_warpper")
       const  { colorStyle, color } = item
       switch (colorStyle) {
        case 1:
         dom.style.background = "linear-gradient(360deg, #E5E2E2 0%, #583EE4 100%)"
         break
        case 2:
         dom.style.background = color
         break
        case 3:
         dom.style.background = `linear-gradient(360deg, #E5E2E2 0%,  ${color} 100%)`
         break
        default:
         dom.style.background =  "linear-gradient(360deg, #E5E2E2 0%, #583EE4 100%)"
       }
       dom.style.backgroundSize = "100% 720px"
       dom.style.backgroundRepeat = "no-repeat"
    },
    bannerClick(item,index){
      sensors.track('xmh5_ziyuanwei_click',{
        ...this.resourceNiche(item),
        xmh5_ziyuanwei_position: index+1
      })
    },
    toDetailBanner(id){
      let index = this.bannerList.findIndex((item, index) => {
        return item.id == id;
      });
      sensors.track('xmh5_ziyuanwei_click',{
        ...this.resourceNiche(this.bannerList[index]),
        xmh5_ziyuanwei_position: index+1
      })
      until.advertisJump(this.bannerList[index],this).then((res)=>{
        console.log(res, 'showVideoshowVideo')
        this.showVideo = true
        this.doctorInfo = {
          ...res,
          contentUrl: res.jumpTargetUrl,
          contentPayUrl: res.jumpTargetUrl,
        }
      })
    },
    // 页面初始化
    initPage() {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    },
    showBanner(isShow){
      this.showbanner = isShow;
    },
    getExpertbanner() {
      const params = {
        pageNum: 1,
        pageSize: 5,
        locationType: 1,
      }
      getPageListOnLine(params).then(res => {
        if(res.code == 200){
          this.bannerList = res.data.data
          this.$nextTick(()=>{
            xmhziyuanwei_data_expo.observe('xmh5_ziyuanwei_view','.milk-swiper-fill',false)
          })
          this.setBackground(this.bannerList[0])
        }
      })
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back(-1)
      } else {
        this.$router.push({ path: '/home' })
      }
    },
    changeeditFlagTip(value) {
      this.editFlagTip = value
    },
    // 切换宝宝后执行的操作
    babyChangeHandler() {
      this.getExpertbanner()
      this.$parent.getMonthsPeriod()
      this.$refs.milkPowderStar.getInfoTagList()
      this.$refs.getQuestion.getQuestion()
    },
    onShowAnswer(show) {
      this.show = show
    },
    onHideAnswer(show) {
      console.log(show)
      this.show = show
    },
    clickSharehandler() {
      sensors.track('milkinfo_home_share_click')
      this.$refs.shareGuide.showShare()
    },
  },
}
</script>
<style lang="less" scoped>
.powdered_Milk_warpper {
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  padding: 14px 16px 36px;
  // background-size: 100% 720px;
  // background-repeat: no-repeat;
  // background-position: 0 -5px;
  // background: linear-gradient(360deg, #E5E2E2 0%, #8B79F1 86%, #583EE4 100%);
}

.noTipsShow {
  // background-position: 0 -46px;
}
.swiper-slide{
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 8px;
}
.power-milk {
  // margin: 8px 16px 0;
  position: relative;
  .milk-swiper{
    overflow:hidden;
    //height: 221px;
    border-radius: 4px;
    margin-top: 8px;
    // margin-bottom: 8px;
    ::v-deep.food_column_swiper{
      //height: 100% !important;
      .swiper-pagination-clickable{
        top: auto
      }
      .swiper-slide{
        height: auto
      }
    }
  }
}
.milktagWrap{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 126px;
  z-index: 999;
  overflow: hidden;
    a{
      display: block;
      width: 100%;
      height: 80px;
    }
}
</style>
